import React from 'react';
import {SelectField, SelectInput} from "react-admin";

const choices = [
    {id: 'CHALLENGE_STATUS_PUBLISHED', name: 'Publié'},
    {id: 'CHALLENGE_STATUS_DRAFT', name: 'Brouillon'},
];

const SelectChallengeStatusInput = (props) => (
    <SelectInput {...props} source="status" choices={choices}/>
);

const SelectChallengeStatusField = (props) => (
    <SelectField {...props} source="status" choices={choices}/>
);

export {SelectChallengeStatusInput, SelectChallengeStatusField}
